import { render } from "./Accordion.vue?vue&type=template&id=8b794a20&scoped=true"
import script from "./Accordion.vue?vue&type=script&lang=js"
export * from "./Accordion.vue?vue&type=script&lang=js"

import "./Accordion.vue?vue&type=style&index=0&id=8b794a20&scoped=true&lang=css"

import exportComponent from "/github/workspace/timmies-helper-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b794a20"]])

export default __exports__